import {AfterViewInit, Component, ElementRef, HostBinding, OnInit, ViewChild} from '@angular/core';
import {MatDialog, MatDialogRef } from '@angular/material/dialog';

/**
 * @title Dialog elements
 */
@Component({
  selector: 'dialog-elements-example',
  templateUrl: './pop-up.component.html',
  styleUrls: ['./pop-up.component.scss'],
})
export class PopUpComponent{

  constructor(public dialog: MatDialog) {}

  openDialog() {
    this.dialog.open(DialogElementsExampleDialog);
  }

  openDialogFull() {
    this.dialog.open(DialogElementsFull);
  }
}


@Component({
  selector: 'dialog-elements-example-dialog',
  templateUrl: 'dialog-elements-example-dialog.html',
})
export class DialogElementsExampleDialog implements AfterViewInit {

  @ViewChild('popupNormal',{read:ElementRef})popupNormal:ElementRef;

  constructor(private dialogRef: MatDialogRef<any>) {}
  ngAfterViewInit(): void {
    this.popupNormal.nativeElement.parentNode.parentNode.parentNode.classList.add("normal-popup");

  }

  close() {
    this.dialogRef.close();
  }
}

@Component({
  selector: 'dialog-element-full',
  templateUrl: 'dialog-element-full.html',
})
export class DialogElementsFull implements AfterViewInit {

  // @HostBinding('class')
  // elementClass = 'full-popup';
  @ViewChild('popup',{read:ElementRef})popup:ElementRef;


  constructor(private dialogRef: MatDialogRef<any>) {}
  ngAfterViewInit(): void {
    this.popup.nativeElement.parentNode.parentNode.parentNode.classList.add("full-popup");

  }


  close() {
    this.dialogRef.close();
  }
}

















